import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { fetchPrefectures } from '../../../services/personProfiles';
import { Prefecture } from '../../../types/personShow';
import { scrollToElementById } from '../../../libs/scrollUtils';

type Props = {
  onChangedBody: (name: string, value: any) => void;
  preferredLocations: string[];
  target: string;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  preferredLocations,
  target,
}) => {
  const [suggestPrefectures] = useState<Prefecture[]>([
    { id: 1, name: '北海道' },
    { id: 13, name: '東京都' },
    { id: 14, name: '神奈川県' },
    { id: 11, name: '埼玉県' },
    { id: 12, name: '千葉県' },
    { id: 23, name: '愛知県' },
    { id: 27, name: '大阪府' },
    { id: 40, name: '福岡県' }
  ]);
  const [prefectures, setPrefectures] = useState<Prefecture[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<string[]>(preferredLocations);

  useEffect(() => {
    setSelectedLocations(Array.from(new Set(preferredLocations)));
  }, [preferredLocations]);

  useEffect(() => {
    const request = async () => {
      try {
        const response = await fetchPrefectures();
        setPrefectures(response.prefectures);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, []);

  const handleClick = (name: string) => {
    const uniqueSelected = [...new Set(selectedLocations)];
    if (uniqueSelected.includes(name)) {
      const updated = uniqueSelected.filter((loc) => loc !== name);
      setSelectedLocations(updated);
      onChangedBody('preferredLocations', updated);
    } else {
      const updated = [...uniqueSelected, name];
      setSelectedLocations(updated);
      onChangedBody('preferredLocations', updated);
    }

    const prefecture = prefectures.find((pref) => pref.name === name);
    if (prefecture) {
      scrollToElementById(`person_show_modal_preferred_location_${prefecture.id}`, 'smooth', 'center');
    }
  };

  return (
    <Presentation
      suggestPrefectures={suggestPrefectures}
      prefectures={prefectures}
      selectedLocations={selectedLocations}
      onClick={handleClick}
    />
  );
};
